import React, { useState } from "react"

import { Loading, Notification } from "@/components"

import Settings from "@/pages/Admin/Plugins/RDStationPlugin/RDStationCRMPlugin/Settings"

import { RDStationCRMPluginSettingsData } from "@/protocols/RdStationPluginProtocol"

import useDidMount from "@/hooks/useDidMount"

import RDStationCRMService from "@/services/RDStationCRM"

import { RDStationCRMPluginSkeleton } from "@/skeletons/Admin/RDStationCRMPluginSkeleton"
import ErrorHandlerService from "@/services/ErrorHandler"

const RDStationCRMPlugin = () => {
	const [loading, setLoading] = useState<boolean>(false)
	const [plugin, setPlugin] = useState<RDStationCRMPluginSettingsData>({} as RDStationCRMPluginSettingsData)

	const handleCheckAuthCredentials = async () => {
		setLoading(true)

		try {
			const response = await RDStationCRMService.checkAuthCredentials()

			setPlugin({
				...plugin,
				...response
			})
		} catch (error) {
			ErrorHandlerService.handle(error as Error)
			Notification.error({ message: "Não foi possível autenticar os dados do plugin." })
		}

		setLoading(false)
	}

	const handleUpdatePlugin = (data: Partial<RDStationCRMPluginSettingsData>) => {
		setPlugin({
			...plugin,
			...data
		})
	}

	useDidMount(() => {
		handleCheckAuthCredentials()
	})

	return (
		<Loading loading={loading} customLoadingElement={<RDStationCRMPluginSkeleton />}>
			<Settings
				plugin={plugin}
				onUpdate={handleUpdatePlugin}
			/>
		</Loading>
	)
}

export default RDStationCRMPlugin
